export const GET_TYPE = 'GET_TYPE';
export const FETCH_CITYRANK_BEGIN = 'FETCH_CITYRANK_BEGIN';
export const FETCH_CITYRANK_SUCCESS = 'FETCH_CITYRANK_SUCCESS';
export const FETCH_CITYRANK_ERROR = 'FETCH_CITYRANK_ERROR';